import React, { FC } from 'react';
import { TDealerLocatorDetailFilterDetails } from '../../types/dealerLocatorDetail.types';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import Picture from '../../../@shared/picture';
import './styles.scss';

const DealerEquipmentsServices: FC<{ filterDetails: TDealerLocatorDetailFilterDetails[]; titeDictonaryKey: string }> = ({
  filterDetails,
  titeDictonaryKey,
}) => {
  if (filterDetails.length === 0) return null;

  return (
    <section className="dealer-equipments-services__wrapper">
      <div className="dealer-equipments-services">
        <h3 className="dealer-equipments-services__title">
          <DictionaryTerm keyword={titeDictonaryKey} />
        </h3>
        <div className="dealer-equipments-services__cards">
          {filterDetails.map(
            ({ Title, Icon }) =>
              (Title || Icon) && (
                <div className="dealer-equipments-services-card">
                  <Picture
                    editorialImageProps={{
                      mobileImage: {
                        value: {
                          src: Icon,
                        },
                      },
                      alt: Title || '',
                      cssClassImageEl: 'dealer-equipments-services-card__image',
                    }}
                  />
                  {Title && <h2 className="dealer-equipments-services-card__title">{Title}</h2>}
                </div>
              )
          )}
        </div>
      </div>
    </section>
  );
};

export default DealerEquipmentsServices;
